module.exports = __webpack_public_path__ + "img/review.2fc7e51d.png";